import React from 'react';
import PropTypes from 'prop-types';

export const AdContainer = ({ height, width }) => (
  <div
    className={`ad-container`}
    style={{
      height: `${height}px` || 0,
      width: `${width}px` || 0
    }}
  >
    AD UNIT of {width} x {height}
  </div>
);

AdContainer.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string
};

AdContainer.defaultProps = {
  height: 'auto',
  width: '100%'
};
